<template>
  <v-card class=" ma-6">
    <v-card-title class="primary--text">
      Articoli
      <div class="flex-grow-1"></div>
      <v-text-field
        v-model="search"
        label="Cerca tra gli articoli"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :search="search"
      :items="articleList"
      :items-per-page="100"
      class="elevation-1 pt-10p"
    >
      <template v-slot:item.action="{ item }">
        <v-icon
          medium
          color="orange accent-3"
          class="mr-2"
          @click="editItem(item)"
        >
          mdi-pen
        </v-icon>
        <v-icon
          medium
          color="red accent-4"
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:no-data>
        <p>Nessun Articolo.</p>
      </template></v-data-table>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  export default {
    name: 'ArticleList',
    data() {
      return {
        search: '',
        headers: [
          { text: 'Azioni', value: 'action', sortable: false },
          { text: 'Titolo', value: 'title' },
          { text: 'Categoria', value: 'category' },
          { text: 'Stato', value: 'status' },
          { text: 'Data Creazione', value: 'created_at' },
        ],
      }
    },
    methods: {
      ...mapActions([
        'fetchAllArticles',
        'setEditMode',
        'setTab',
        'editArticle'
      ]),
      ...mapMutations([
        'SET_ARTICLE_TAB',
      ]),
      editItem(item) {

        this.SET_ARTICLE_TAB('tab-2')
        const index = this.articleList.indexOf(item)

        console.log(this.articleList[index])
        this.setEditMode(this.articleList[index])
      },

      deleteItem(item) {
        const index = this.articleList.indexOf(item)
        console.log(index)
      },
    },
    computed: {
      ...mapGetters([
        'articleList'
      ])
    },
    mounted() {
      this.fetchAllArticles()
    }
  }
</script>